import React from 'react'
import type { FieldSummary } from '@core/Areas/RaceCardFixedOnly/Types/FieldSummary'
import {
  PropositionJockeyNameStyled,
  PropositionStrongFieldsStyled,
  PropositionSummaryResultsStyled,
  PropositionTrainerNameStyled,
  SelectionFormTableStyled,
} from '@core/Areas/RaceCardFixedOnly/RaceCardFixedOnly.styles'
import { JockeyName } from '@core/Areas/RaceCard/Components/JockeyName'

type Props = {
  summary: FieldSummary
}
export const RaceFieldSummaryResults: React.FC<Props> = ({ summary }) => {
  if (!summary) return null

  return (
    <PropositionSummaryResultsStyled>
      <SelectionFormTableStyled>
        <PropositionJockeyNameStyled>
          <JockeyName
            jockeyName={summary.jockeyName ?? ''}
            isRiderChanged={summary.isRiderChanged}
          />
        </PropositionJockeyNameStyled>
        <PropositionTrainerNameStyled>
          <PropositionStrongFieldsStyled>T:</PropositionStrongFieldsStyled>
          <span>{summary.trainerName}</span>
        </PropositionTrainerNameStyled>
      </SelectionFormTableStyled>
    </PropositionSummaryResultsStyled>
  )
}
